<template>
    <Dialog
        :header="$t('programs_in_varosliget.choose_date')"
        :visible.sync="isOpen"
        :dismissable-mask="true"
        :modal="true"
        @hide="$emit('hide')"
    >
        <slot />

        <template #footer>
            <slot name="footer" />
        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
    name: 'BaseModal',
    components: {
        Dialog,
    },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    created() {
        this.$nuxt.$on('open-modal', (id) => {
            if (id === this.id) {
                this.isOpen = true;
            }
        });
        this.$nuxt.$on('close-modal', (id) => {
            if (id === this.id) {
                this.isOpen = false;
            }
        });
    },
};
</script>

<style scoped></style>

<style></style>
